import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';

import { NgUtils, TiimePipesModule } from 'tiime-expert-utils';
import {
  TableAnchorComponent,
  TableDataSourceBase,
  TiimeContainerModule,
  TiimePaginatorModule,
  TiimeSortModule,
  TiimeTableModule,
  TiimeTooltipModule
} from 'tiime-material';

import { Audit } from '@models/audit';
import { StatusType } from '@modules/core/types/status-type.type';
import { StatusComponent } from '@shared-components/status/status.component';
import { StatusColorPipe } from '@shared-pipes/status-color/status-color.pipe';
import { StatusLabelPipe } from '@shared-pipes/status-label/status-label.pipe';
import { TimelineItemDescriptionPipe } from '@shared-pipes/timeline-item-description.pipe';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TiimeTableModule,
    TiimeSortModule,
    TiimePaginatorModule,
    TiimePipesModule,
    TiimeContainerModule,
    StatusComponent,
    TiimeTooltipModule,
    TimelineItemDescriptionPipe,
    StatusColorPipe,
    StatusLabelPipe
  ],
  selector: 'app-entity-history-table',
  templateUrl: './entity-history-table.component.html',
  styleUrls: ['./entity-history-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityHistoryTableComponent extends TableDataSourceBase<Audit> {
  @Input({ required: true }) audits: Audit[];
  @Input() statusType: StatusType = 'declaration';

  @ViewChild(TableAnchorComponent) tableAnchorComponent: TableAnchorComponent;

  readonly ColumnNames = {
    date: 'date',
    user: 'user',
    status: 'status'
  };
  readonly displayedColumns = [this.ColumnNames.date, this.ColumnNames.user, this.ColumnNames.status];
  readonly trackById = NgUtils.trackById;
}
